import * as React from 'react'

import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'

import CTASimple from '../../wiki/cta-simple'
import Routes from 'utils/routes'

const Wrapper = styled(Stack)`
    max-width: 25%;
    min-width: 260px;
    margin-top: calc(${({ theme }) => theme.spacing(1)} + 48px);
    margin-left: ${({ theme }) => theme.spacing(1)};
    padding-top: ${({ theme }) => theme.spacing(2)};
`

export default function RightPanel() {
    return (
        <Wrapper direction={'column'} spacing={2} sx={{ display: { xs: 'none', lg: 'block' } }}>
            <CTASimple
                color="#00000"
                title="Iscriviti a Devv 🔥"
                description="Diventa un eroe della programmazione e trova lavoro"
                buttonText="Iscriviti ora"
                buttonLink={Routes.SignUp}
            />
            <CTASimple
                color="#00000"
                title="Scopri i migliori corsi 😱"
                description="Scegli tra 150+ percorsi gratuiti, impara una nuova skill e raggiungi i tuoi obiettivi"
                buttonText="Scopri i corsi"
                buttonLink={Routes.Catalog}
            />
        </Wrapper>
    )
}
